<template>
  <v-select
    :items="values"
    label="Loja Teste"
    item-text="text"
    item-value="value"
    v-model="valueSelecionado"
  />
</template>

<script>
export default {
  name: 'FiltroLojaTeste',
  data() {
    return {
      values: [
        {
          text: 'Todos as lojas',
          value: null
        },
        {
          text: 'Sim',
          value: true
        },
        {
          text: 'Não',
          value: false
        }
      ],
      valueSelecionado: false
    }
  },
  watch: {
    valueSelecionado() {
      this.emitirValueSelecionado()
    }
  },
  mounted() {
    this.emitirValueSelecionado()
  },
  methods: {
    emitirValueSelecionado() {
      this.$emit('filtrar-loja-teste', {
        loja_teste: this.valueSelecionado
      })
    }
  }
}
</script>
